<div class="alert alert-danger mt-4" role="alert" *ngIf="errorMessage !== ''">
  {{ errorMessage }}
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="(errorMessage === '') && (serverError === null)">

  <h2>
    Staff Time Tracking
    <span *ngIf="loadingOrganizationConfig" class="text-secondary">- Loading...</span>
  </h2>

  <div class="form-group" *ngIf="!loadingOrganizationConfig">
    <label for="timeTrackingEnabledSelect">Do you need staff to clock in/out in Capitan?</label>
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-5">
        <select id="timeTrackingEnabledSelect" name="time_tracking_enabled"
                class="form-control"
                [(ngModel)]="orgConfig.time_tracking_enabled" (ngModelChange)="saveOrganizationConfig()"
                [class.disabled]="loadingEdit"
                [disabled]="loadingEdit">
          <option [ngValue]="true">Yes</option>
          <option [ngValue]="false">No</option>
        </select>
      </div>
    </div>
  </div>

  <div *ngIf="!loadingOrganizationConfig && (orgConfig.time_tracking_enabled)">

    <hr>

    <h4>Time Tracking Roles</h4>

    <p class="text-secondary">
      Time tracking roles are used to track which job a staff member was performing during each shift.
    </p>

    <div class="row">
      <div class="col-xl-6 col-lg-8">

        <div class="alert"
             [class.alert-success]="modalResult.status === CallbackResultStatus.success"
             *ngIf="modalResult !== null">
          {{ modalResult.text }}
        </div>

        <div class="rounded-table-wrapper">
          <table class="table">

            <thead>
              <tr>
                <th>Name</th>
                <th></th>
              </tr>
            </thead>

            <tbody>

              <ng-container *ngIf="roleResultsPresent()">
                <tr *ngFor="let role of roleList">
                  <td>{{ role.name }}</td>
                  <td class="table-button-cell">
                    <button class="btn btn-outline-primary btn-sm float-right"
                            [class.disabled]="loadingEdit"
                            [disabled]="loadingEdit"
                            (click)="openEditRoleModal(role)">
                      Edit
                    </button>
                    <button class="btn btn-outline-danger btn-sm float-right mr-2"
                            [class.disabled]="loadingEdit"
                            [disabled]="loadingEdit"
                            (click)="openRemoveRoleModal(role)">
                      Remove
                    </button>
                  </td>
                </tr>
              </ng-container>

              <ng-container *ngIf="!roleResultsPresent()">
              <tr>
                <td colspan="99">
                  {{ loadingRoles ? 'Loading...' : 'No time tracking roles' }}
                </td>
              </tr>
              </ng-container>

              <tr *ngIf="!loadingRoles">
                <td colspan="99" class="table-button-cell">
                  <button class="btn btn-outline-success btn-block"
                          [class.disabled]="loadingEdit"
                          [disabled]="loadingEdit"
                          (click)="openAddRoleModal()">
                    Click to add
                  </button>
                </td>
              </tr>

            </tbody>

          </table>
        </div>

      </div>
    </div>

  </div>

  <div class="floating-alert-container">
    <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
      {{ successMessage }}
      <button type="button" class="close" (click)="successMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
      <button type="button" class="close" (click)="errorMessage = ''">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>

    <div class="alert alert-info" role="alert" *ngIf="loadingEdit">
      Saving changes...
    </div>
  </div>
</div>
